module.exports = __webpack_public_path__ + "img/SX.a1a454be.png";